module.exports = __webpack_public_path__ + "static/product-pa50-coyote-tan-2c57d9741fb0c283579e4723e1248f31.png";